import { combineReducers } from 'redux'
import { reducer as authRedux } from './AuthRedux'
import { reducer as filesRedux } from './FilesRedux'
import { reducer as destinationRedux } from './DestinationRedux'
import { reducer as attractionRedux } from './AttractionRedux'
import { reducer as presetRedux } from './PresetRedux'
import { reducer as popularAttractionRedux } from './PopularAttractionRedux'
import { reducer as couponRedux } from './CouponRedux'
import { reducer as couponProviderRedux } from './CouponProviderRedux'
import { reducer as couponPresetRedux } from './CouponPresetRedux'
import { reducer as productRedux } from './ProductRedux'
import { reducer as eventsRedux } from './EventsRedux'
import { reducer as insuranceRedux } from './InsuranceRedux'
import { reducer as bannerRedux } from './BannerRedux'
import { reducer as markupRedux } from './MarkupRedux'
import { reducer as exchangeRateRedux } from './ExchangeRateRedux'
import { reducer as userRedux } from './UserRedux'
import { reducer as orderRedux } from './OrderRedux'
import { reducer as transferHistoryRedux } from './TransferHistoryRedux'
import { reducer as reviewRedux } from './ReviewRedux'
import { reducer as dbRedux } from './DbRedux'
import { reducer as categoryRedux } from './CategoryRedux'
import { reducer as sizeRedux } from './SizeRedux'
import { reducer as colourRedux } from './ColourRedux'
import { reducer as brandRedux } from './BrandRedux'
import { reducer as warehouseRedux } from './WarehouseRedux'
import { reducer as inventoryRedux } from './InventoryRedux'
import { reducer as supplierRedux } from './SupplierRedux'
import { reducer as locationRedux } from './LocationRedux'
import { reducer as ecommerceProductRedux } from './EcommerceProductRedux'
import { reducer as ecommerceOrderRedux } from './EcommerceOrderRedux'
import { reducer as sectionRedux } from './SectionRedux'
import { reducer as attractionPromoRedux } from './AttractionPromoRedux'
import { reducer as failedTransactionRedux } from './FailedTransactionRedux'
import { reducer as schedulerRedux } from './SchedulerRedux'
import { reducer as cronReportRedux } from './CronReportRedux'
import { reducer as promoSectionRedux } from './PromoSectionRedux'
import { reducer as esimsRedux } from './EsimRedux'
import CreateStore from './store'
import rootSaga from '../Sagas/'

export default (initialState:any, options:any) => {
  /* ------------- Assemble The Reducers ------------- */
  const rootReducer = combineReducers({
    auth: authRedux,
    files: filesRedux,
    destination: destinationRedux,
    attraction: attractionRedux,
    popularAttraction: popularAttractionRedux,
    preset: presetRedux,
    coupon: couponRedux,
    couponProvider: couponProviderRedux,
    couponPreset: couponPresetRedux,
    product: productRedux,
    banner: bannerRedux,
    markup: markupRedux,
    exchangeRate: exchangeRateRedux,
    user: userRedux,
    order: orderRedux,
    transfer_history: transferHistoryRedux,
    review: reviewRedux,
    database: dbRedux,
    category: categoryRedux,
    size: sizeRedux,
    colour: colourRedux,
    brand: brandRedux,
    warehouse: warehouseRedux,
    inventory: inventoryRedux,
    supplier: supplierRedux,
    location: locationRedux,
    ecommerceProduct: ecommerceProductRedux,
    ecommerceOrder: ecommerceOrderRedux,
    events: eventsRedux,
    insurance: insuranceRedux,
    section: sectionRedux,
    attractionPromo: attractionPromoRedux,
    failedTransaction: failedTransactionRedux,
    scheduler: schedulerRedux,
    cronReport: cronReportRedux,
    promoSection: promoSectionRedux,
    esims: esimsRedux
  })

  return CreateStore(rootReducer, rootSaga, initialState)
}



// WEBPACK FOOTER //
// ./src/Redux/index.js